import styled from 'styled-components'

export const PageWrapper = styled.div`
  //max-width: 1024px;
  width: 80%;
  height: 100%;
  padding-top: 2rem;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 100%;
  `}
  .stakeList {
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: space-around;
    flex-wrap: wrap;
  }
`
